module.exports = __webpack_public_path__ + "img/ambiental-4.36ad6389.jpg";